import { Box, Checkbox } from '@mui/material'
import { Row } from '../../store/types/utils/DataTableUtils'
import React, { useEffect } from 'react'
import ReportPopupData from '../../store/types/utils/ReportPopupUtil'

interface DataTableTileProps {
  renderTileContent: (row: Row, index: string, checkbox?: React.ReactNode) => React.ReactNode
  data: Row
  index: string
  renderCheckbox?: boolean
  updateSelectedData?: (selectedIds: ReportPopupData[]) => void
  selected: Row[]
  setSelected: React.Dispatch<React.SetStateAction<Row[]>>
  singleSelection: boolean
}

const DataTableTile = ({
  renderTileContent,
  data,
  index,
  renderCheckbox,
  updateSelectedData,
  setSelected,
  selected,
  singleSelection,
}: DataTableTileProps) => {



  const handleClick = (_: React.MouseEvent<unknown>, row: Row) => {
    if (singleSelection) {
      // If single selection is enabled, only keep the current row selected
      setSelected([row]);
    } else {
      // Multi-selection logic
      const indexes = selected.map(entry => entry.id);
      const selectedIndex = indexes.indexOf(row.id);
      let newSelected: Row[] = [];

      switch (true) {
        case selectedIndex === -1:
          newSelected = newSelected.concat(selected, row);
          break;

        case selectedIndex === 0:
          newSelected = newSelected.concat(selected.slice(1));
          break;

        case selectedIndex === selected.length - 1:
          newSelected = newSelected.concat(selected.slice(0, -1));
          break;

        case selectedIndex > 0:
          newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
          break;

        default:
          break;
      }

      setSelected(newSelected);
    }
  };


  useEffect(() => {
    const selectedData = selected.map(singleData => ({
      id: singleData.id,
      leaderIds: singleData.leader
        ? [singleData.leader.id]
        : singleData.leaders?.map((leader: { id: any }) => leader.id),
    }))
    if (updateSelectedData !== undefined) {
      updateSelectedData(selectedData)
    }
  }, [selected, updateSelectedData])

  const checkbox = renderCheckbox ? (
    <Checkbox onClick={event => handleClick(event, data)} checked={selected.some(item => item.id === data.id)} />
  ) : null

  return (
    <Box
      sx={{
        width: '100%',
        border: '1px solid',
        borderColor: 'background.elevation8',
        borderRadius: 1,
        padding: '12px',
        backgroundColor: 'background.elevation1',
        marginBottom: 2,
      }}
    >
      {renderTileContent(data, index, checkbox)}
    </Box>
  )
}

export default DataTableTile
